var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRapidsenseNotext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 340 387",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M160.84 2.43409C166.462 -0.81131 173.387 -0.811368 179.008 2.43394L330.771 90.0518C336.392 93.2972 339.855 99.295 339.855 105.786V281.021C339.855 287.512 336.392 293.51 330.771 296.755L289.317 320.688L229.705 286.428L271.292 262.418C276.913 259.172 280.376 253.175 280.376 246.684V140.123C280.376 133.632 276.913 127.635 271.292 124.389L179.008 71.1089C173.387 67.8634 166.462 67.8634 160.84 71.1089L68.5571 124.389C62.936 127.635 59.4732 133.632 59.4732 140.123V325.848L9.0839 296.755C3.46276 293.51 0 287.512 0 281.021V105.786C0 99.2949 3.46276 93.2972 9.0839 90.0518L160.84 2.43409Z",
    fill: "#FFFFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M162.681 316.626L229.669 355.125L179.008 384.373C173.387 387.618 166.462 387.618 160.84 384.373L118.946 360.185V291.51L160.84 315.698C161.44 316.044 162.055 316.354 162.681 316.626Z",
    fill: "#FFFFFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M179.008 139.783C173.387 136.538 166.462 136.538 160.84 139.783L128.03 158.726C122.409 161.972 118.946 167.969 118.946 174.46V212.347C118.946 218.837 122.409 224.835 128.03 228.08L160.84 247.024C166.462 250.269 173.387 250.269 179.008 247.024L211.818 228.08C217.44 224.835 220.902 218.837 220.902 212.347V174.46C220.902 167.969 217.44 161.972 211.818 158.726L179.008 139.783Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRapidsenseNotext);
export default __webpack_public_path__ + "static/media/rapidsense_notext.b677f7a2984b92a8d718c8695deee565.svg";
export { ForwardRef as ReactComponent };